var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73096 5.49805C2.59033 5.49805 2.47021 5.43555 2.37061 5.31055L0.853027 3.41211C0.815918 3.36719 0.788574 3.32324 0.770996 3.28027C0.755371 3.2373 0.747559 3.19336 0.747559 3.14844C0.747559 3.04688 0.780762 2.96289 0.847168 2.89648C0.915527 2.83008 1.00146 2.79688 1.10498 2.79688C1.22412 2.79688 1.32471 2.85059 1.40674 2.95801L2.71924 4.64258L5.26221 0.602539C5.30713 0.53418 5.35303 0.486328 5.3999 0.458984C5.44678 0.429688 5.50732 0.415039 5.58154 0.415039C5.68311 0.415039 5.76611 0.447266 5.83057 0.511719C5.89502 0.574219 5.92725 0.65625 5.92725 0.757812C5.92725 0.798828 5.92041 0.84082 5.90674 0.883789C5.89307 0.924805 5.87158 0.96875 5.84229 1.01562L3.08838 5.30762C3.00244 5.43457 2.8833 5.49805 2.73096 5.49805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.52e65c206daa2cf8993301072500295b.svg";
export { ForwardRef as ReactComponent };